import React, { useEffect, useState } from 'react'
import './homepage.styles.scss'

import { Routes, Route, Navigate } from 'react-router-dom'

import Header from '@/components/header/header.component'
import HomeContent from '@/components/HOME/home-content/home-content.component'
import Footer from '@/components/footer/footer.component'
import LandingContent from '@/components/landing-content/landing-content.component'
import { Sources } from '@/forms/formTypes'
import Header2025 from '../../components/header-2025/header-2025.component'
import MyEvalsList from '../../components/HOME/home-content/my-evals-list.component'


const HomePage = () => {

	const [ platform, setPlatform ] = useState(null)
	
	useEffect(() => {
		const header = document.getElementsByClassName('header-2025')[0]
		console.log('source', platform)
		if (platform && platform !== 'eln' && platform !== 'ipa') {
			const sourceCat = Sources[platform].cat;
			header.classList.add(sourceCat)
			setPlatform(sourceCat)
		} else if (platform) {
			header.classList.add(platform)
		} else {
			header.classList.remove('eln')
			header.classList.remove('ipa')
		}
		

	}, [platform])

	return (
		<div className='homepage'>
			<Header2025 platform={platform} />
			<div className='homepage_content'>
				<Routes>
					<Route path='' element={<Navigate to="/" />} ></Route>
					<Route path='eln' element={
						<MyEvalsList setPlatform={setPlatform} type={'eln'} />
					}></Route>
					<Route path='ipa' element={
						<MyEvalsList setPlatform={setPlatform} type={'ipa'} />
					}></Route>
				</Routes>
			</div>
			<Footer platform={platform} />
		</div>
	)
}

export default HomePage